import React from 'react';

const HoldingCert: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M26.265 92.611c2.436-1.187 7.377-8.99 7.377-8.99-.864 1.833-1.365 3.613-1.572 5.097-.138 1.013-.242 2.27.104 3.247 1.105 3.003 2.574-.593 3.093-2.094-.139 1.1-.519 2.286.518 2.723 1.935.82 2.384-1.38 3.04-2.34-.068.42-.293 1.083.018 1.45.397.453.795-.227 1.261-.542-.051.995.225 1.746 1.262 1.275.864-.402 1.019-1.17 2.038-1.275.035 1.816 1.434 1.554 3.076 1.606h2.816"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M56.64 67.7h13.563l9.97 12.499 16.638-9.13c14.721 2.164 22.081 10.37 22.461 27.007V117M56.64 89.015l6.669 2.322V117m25.156-51.797c11.836 0 21.442-9.497 21.442-21.229 0-11.731-9.606-21.228-21.442-21.228-11.835 0-21.442 9.497-21.442 21.228 0 11.732 9.59 21.229 21.442 21.229zM14.966 89.015c7.135.14 12.94-4.137 12.94-11.016 0-9.636-6.997-13.512-13.044-12.5-6.255 1.048-6.082 5.325-6.134 11.662-.086 9.288 1.348 11.767 6.238 11.854zM101.13 117v-13.983M19.354 65.64v-7.123"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M38.515 48.618h18.124v50.104H19.354v-10.23"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M25.436 33.238c5.01 0 9.537.698 13.494 2.06v9.48c0 11.679-10.523 16.008-13.2 16.916-2.696-.803-13.218-4.749-13.218-16.917v-9.514c2.85-1.082 6.72-2.025 12.94-2.025h-.016z"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M25.142 39.348c-2.972 0-5.27.314-6.825.699v4.975c0 6.11 4.406 8.746 6.825 9.724V39.348z"
    ></path>
  </svg>
);

export default HoldingCert;
